import React, { useCallback, useEffect, useRef, useState } from "react";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";
import Input from "../ui/Input";
import Checkbox from "../ui/Checkbox";
import Label from "../ui/Label";
import Button from "../ui/Button";
import Space from "../ui/Space";
import InventoryPubstock from "./InventoryPubstock";
import { ROUTES } from "../utils/Routes";
import CustomersController from "../controllers/CustomersController";
import { createScreen } from "../hooks/createScreen";
import { calculateProfitMargin, calculateSellPrice, kbdEvent, requestClerkCode, requireLogin, save, showConfirm } from "../utils/Utils";
import DateField from "../ui/DateField";
import { drawPicker } from "../popovers/Picker";
import { ENUMS } from "../utils/Enums";
import dayjs from "dayjs";
import { pubCall } from "../utils/PubSub";
import { showError, showMessage } from "../ui/Message";
import Spin from "../ui/Spin";
import OtherConditions from "./OtherConditions";
import { order_structure } from "../data_structures/Stock";
import { getSignal } from "../App";
import PriceField from "../ui/PriceField";
import Table from "../ui/Table";



export default function InventoryOrders(props) {
    const { controller = "", conditionSelected = false, setConditionSelected = () => { }, togglePubstock = () => { }, fullData = {}, setFullData = () => { }, route = "", other_conditions = [], switchView = () => { }, state = {}, sell_price = 0, pending_orders = { rows: [], total: 0 }, signal = {} } = props;

    const refs = useRef({});
    const rowRefs = useRef({});
    const [focusedCell, setFocusedCell] = useState({});
    const [expandedRows, setExpandedRows] = useState({});
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(false);
    const [current, setCurrent] = useState({})
    const _signal = signal;
    const session = _signal?.value?.session;
    const splitter = session?.is_splitter_active;
    const largestChainNum = Math.max(0, ...(session?.ms_info?.map(obj => obj.chain_num) ?? []));
    const stores = session?.ms_info.filter(item => item.is_splitter_active) ?? [];
    const myStoreIndex = stores.findIndex(item => item.san === session?.store_san);
    const full_split = useRef(new Array(largestChainNum + 1).fill(0));
    const row_key = "";

    const isEditOrder = useRef(false);

    const addDefaultSell = (_arr) => {
        const update = _arr.map(item => ({
            ...item,
            sell_price: sell_price,
            store_profit_margin: calculateProfitMargin(sell_price, item.invoice_price, item.supplier_discount, 1)
        }));
        return update;
    }


    useEffect(() => {

        if (window.bm_state.value === ROUTES.INVENTORY.ORDER) {
            switchView("inventory");
        }



        if (isEditOrder?.current && window.bm_state.value === ROUTES.INVENTORY.INVENTORY) {
            setOrders(addDefaultSell(pending_orders?.rows));
        }

        const onAddOrder = (e) => addOrder(e.detail);
        const onEditOrder = (e) => editOrder(e.detail);
        window.addEventListener("editOrder", onEditOrder);
        window.addEventListener("addOrder", onAddOrder);
        return () => {
            window.removeEventListener("addOrder", onAddOrder);
            window.removeEventListener("editOrder", onEditOrder)
        }
    }, [pending_orders, state.view]);


    const editOrder = (_history_item) => {



        isEditOrder.current = true;
        if (!_history_item) {

            switchView("order");
            window.bm_state.value = route;

            setOrders(addDefaultSell([pending_orders?.rows[0]]))
            setTimeout(() => {
                setExpandedRows({ 0: true })
                setFocusedCell({ row: 0, col: "quantity" })
            }, 1)
            setLoading(false);
            return;
        }

        switchView("order");

        if (_history_item?.new) {
            window.bm_state.value = route;
            setOrders(addDefaultSell([{ ..._history_item }]))
            setTimeout(() => {
                setExpandedRows({ 0: true })
                setFocusedCell({ row: 0, col: "customer.name" })
            }, 100)
            return;
        }

        setOrders([]);
        setExpandedRows({})
        setFocusedCell({})

        setLoading(true);
        pubCall("order.getInfo", { order_id: _history_item.history_id }, (_s, _r) => {
            if (_s) {

                window.bm_state.value = route;
                setOrders(addDefaultSell([{ ..._r }]))
                setTimeout(() => {
                    setExpandedRows({ 0: true })
                    setFocusedCell({ row: 0, col: "quantity" })
                }, 1)
            }
            setLoading(false);
        })
    }



    const addOrder = (_data) => {

        return;

        if (_data) {
            addAdditive(_data);
        } else {

            editOrder(false)
        }


    };


    const saveOrder = (_order, _api, _row) => {

        requestAnimationFrame(() => {

        })

        setLoading(true)
        // Remove order
        if (_order.quantity === 0) {
            if (_row) {
                removeOrder(_row);
            } else {
                showError({ error: "Quantity required." })
            }
            setLoading(false);
            return;
        }

        if (_api === "order.addItem") {
            // update placeholder
            let _placeholder = addDefaultSell([pending_orders.rows[0]]);
            setOrders(orders => orders.map(row => row.order_id === "" ? { ...row, ..._placeholder[0] } : row));
        }

        // SPLITTER
        if (splitter && full_split?.current) {
            // if doesn't match or quantity matches "my" store, set to empty; 
            if (full_split.current[myStoreIndex] === parseInt(_order.quantity) || full_split.current.reduce((a, b) => a + b, 0) !== parseInt(_order.quantity)) {
                _order.ms_split = []
            } else {
                _order.ms_split = full_split.current;
            }
        }

        // don't split with customer
        if (splitter && _order.customer) {
            _order.ms_split = []
        }



        pubCall(_api, { order_item: _order, require_clerk_code: true }, (_s, _r) => {
            if (_s) {
                showMessage((_row) ? "Order updated." : "Order added");
                if (_row) {
                    // update
                    setOrders(orders => orders.map(row => row.order_id === _r?.order_id ? { ...row, ..._r } : row));
                } else {
                    if (_api === "order.additiveItem") {
                        // update set
                        setCanFetchMore(true);
                        setOrders(addDefaultSell(_r.rows));
                    } else {
                        // add to the second row...
                        let _odr = addDefaultSell([_r]);
                        setOrders(orders => [orders[0], _odr[0], ...orders.slice(1)]);
                    }
                }

                switchView("inventory");
                const event = new CustomEvent("callExtra", {});
                window.dispatchEvent(event);

            } else {
                showError(_r);
            }
            setLoading(false);
            setExpandedRows({});
        })


    }

    const convertDiscountToInt = (_discount, _profit_margin = 40) => {

        if (_discount == 'SH') {
            _discount = 40;
        }

        if (_discount == 'RG') {
            _discount = _profit_margin;
        }

        if (_discount == 'BX' || _discount == 'HI' || _discount == '') {
            _discount = 40;
        }

        if (_discount == 'NT') {
            _discount = 0;
        }
        _discount -= 0;
        return _discount;
    }

    const addAdditive = (_pubstock) => {



        if (window.bm_state.route !== route) {
            setFocusedCell({ row: 0, col: "qty" })
        }

        let _obj = { ...pending_orders?.rows?.[0] } || {}

        if (_pubstock) {
            _obj.supplier = _pubstock.supplier.slice(0, 3);
            _obj.invoice_price = parseFloat(_pubstock.supplier_price);
            _obj.supplier_discount = convertDiscountToInt(_pubstock.discount);
        }

        _obj.quantity = 1;
        saveOrder(_obj, "order.additiveItem", 0)
    }

    const save = () => {
        const { row, col } = focusedCell;
        const api = (current?.order_id) ? "order.editItem" : "order.addItem";
        const order = current;



        if (sell_price !== order.sell_price) {
            const { row, col } = focusedCell;
            const refKey = `${row}-${col}`;
            refs.current[refKey].blur();
            showConfirm({
                controller : controller,
                route,
                description: (
                    <div style={{ textAlign: "center", "width": "330px" }}>
                        You are changing the inventory price: from<strong> {parseFloat(sell_price).toFixed(2)}</strong> to <strong>{parseFloat(order.sell_price).toFixed(2)}</strong>.
                        <div className="shim" /><div>Are you sure?</div><div className="shim" />
                    </div>
                ),
                title: "Inventory price change",
                callback: confirmed => {
                    if (confirmed) {
                        updateSellPrice(order.sell_price);
                    } else {
                        updateOrder(row, "sell_price", sell_price);
                        updateOrder(row, "store_profit_margin", calculateProfitMargin(sell_price, order.invoice_price, order.supplier_discount, 1))
                    }
                    refs.current[refKey].focus();
                    saveOrder(order, api, row);
                }
            });
        } else {
            saveOrder(order, api, row);
        }
        return;
    }


    const removeOrder = (rowIndex) => {

        const order = orders[rowIndex];
        const { order_id = "" } = order;
        setLoading(true)
        pubCall("order.removeItem", { order_id: order_id, require_clerk_code: true }, (_s, _r) => {
            if (_s) {
                const event = new CustomEvent("callExtra", {});
                window.dispatchEvent(event);
                showMessage("Order removed.");
            } else {
                showError(_r);
            }
            setLoading(false)
        })
    };

    const canEdit = (_row) => {
        if (!_row.order_id) {
            // edit anything new...
            return true;
        }
        // can't edit returns or cancelled
        if (_row.status.toLowerCase().startsWith("r") || _row.status.toLowerCase().startsWith("c")) {
            return false;
        }

        return true;
    }

    const editProps = (col, order, rowIndex) => {
        if (!col) { return }
        const inEditView = state.view === "order" || state.view === "orders";
        let _can_edit = (canEdit(order) && focusedCell.row == rowIndex && inEditView);
        return {
            edit: _can_edit,
            controlled: true,
            value: (order.supplier === "" && rowIndex === 0) ? "" : getValue(order, col.key, rowIndex),
            onChange: (e) => updateOrder(rowIndex, col.key, e),
            ref: (el) => (refs.current[`${rowIndex}-${col.key}`] = el),

            onFocus: () => {

                setFocusedCell({ row: rowIndex, col: col.key })
            },
            onClick: () => {

                setFocusedCell({ row: rowIndex, col: col.key })
            },
            onEnter: (e) => {
                handleKeyNavigation(KBD.TAB)
            }
        }
    };


    const updateSellPrice = (_sell_price) => {

        setLoading(true);
        const _stock_data = { ...fullData.stock, "price": parseFloat(_sell_price) }
        pubCall("stock.edit", { stock: _stock_data }, (_s, _r) => {
            if (_s) {
                setLoading(false);
                setFullData({ ...fullData, "stock": _r });
                setOrders(addDefaultSell(orders))
                showMessage("Stock price updated.")
            } else {
                showError(_r.error)
            }
        })

    }


    const columns = [
        {
            key: "supplier", label: <><span style={{ "color": "var(--text)" }}>&nbsp;Orders</span></>, render: (col, order, rowIndex) => {
                return (
                    <Input
                        placeholder="Supp..."
                        {...editProps(col, order, rowIndex)}
                        width={65}
                        maxLength={5}
                        uppercase
                    />
                )
            }
        },
        {
            key: "order_separator", label: "Grp", render: (col, order, rowIndex) => {
                return (
                    <Input
                        {...editProps(col, order, rowIndex)}
                        alpha
                        width={20}
                        maxLength={1}
                        uppercase
                    />
                )
            }
        },
        {
            key: "quantity", label: "Qty", render: (col, order, rowIndex) => {

                if (splitter) {


                    return (
                        <Input
                            {...editProps(col, order, rowIndex)}
                            onEnter={(e) => { handleSplitUpdate("quantity", e, rowIndex, order); handleKeyNavigation(KBD.TAB) }}
                            onBlur={(e) => handleSplitUpdate("quantity", e, rowIndex, order)}
                            width={33}
                            min
                            className={(focusedCell.row == rowIndex && (state.view === "orders" || state.view === "order")) ? "" : "text-orange-bg text-black"}
                            number
                            right
                        />
                    )
                }

                return (
                    <Input
                        {...editProps(col, order, rowIndex)}
                        width={33}
                        min
                        className={(focusedCell.row == rowIndex && (state.view === "orders")) ? "text-orange-bg" : "text-orange-bg text-black"}
                        number
                        right
                    />
                )
            }
        },

        {
            key: "invoice_price", label: "SupPr", render: (col, order, rowIndex) => {

                return (
                    <PriceField
                        {...editProps(col, order, rowIndex)}
                        onChange={(e) => {
                            setCurrent({ ...current, "invoice_price": e, "store_profit_margin": calculateProfitMargin(current.sell_price, e, current.supplier_discount, 1) })
                        }}
                        width={60}
                        min
                        price

                        right
                    />
                )
            }
        },
        {
            key: "supplier_discount", label: "Disc", render: (col, order, rowIndex) => {
                return (
                    <Input
                        {...editProps(col, order, rowIndex)}
                        onChange={(e) => {
                            setCurrent({ ...current, "supplier_discount": e, "store_profit_margin": calculateProfitMargin(current.sell_price, current.invoice_price, e, 1) })
                        }}
                        width={22}
                        maxLength={2}
                        number
                        right
                    />
                )
            }
        },

        {
            key: "sell_price", label: "Sell", render: (col, order, rowIndex) => {

                return (
                    <PriceField
                        {...editProps(col, order, rowIndex)}
                        onChange={(e) => {
                            setCurrent({ ...current, "sell_price": e, "store_profit_margin": calculateProfitMargin(e, current.invoice_price, current.supplier_discount, 1) })
                        }}
                        width={60}
                        min
                        price
                        right
                    />
                )
            }
        },
        {
            key: "store_profit_margin", label: "PM", render: (col, order, rowIndex) => {


                return (
                    <Input
                        {...editProps(col, order, rowIndex)}
                        onChange={(e) => {
                            setCurrent({ ...current, "store_profit_margin": e, "sell_price": calculateSellPrice(current.invoice_price, current.supplier_discount, e, 1) })
                        }}
                        onEnter={() => { if (expandedRows[rowIndex]) { setFocusedCell({ row: rowIndex, col: "customer.name" }) } else { kbdEvent(KBD.PAGE_DOWN) } }}
                        width={25}
                        min
                        right
                        number
                        maxLength={2}
                    />
                )
            }
        },

        {
            key: "remove", label: <></>, render: (col, order, rowIndex) => {
                return (
                    <div><Button className={(order?.order_id) ? "ui-tbl-btn" : "ui-tbl-btn disabled"} {...{
                        ...editProps(col, order, rowIndex), onClick: () => {

                            if (window.bm_state.value !== route) {
                                kbdEvent(KBD.O);
                                return;
                            }

                            if (order?.order_id) {
                                removeOrder(rowIndex)
                            }

                        }
                    }}>X</Button></div>
                )
            }
        },

        {
            key: "customer", label: <div style={{ "textAlign": "right", "pointerEvents": (state.view === "orders") ? "none" : "all" }}><Button disabled={state.view === "orders"} onClick={() => kbdEvent(KBD.O)} type="link">New+</Button></div>, render: (col, order, rowIndex) => {
                return (
                    <div style={{ "textAlign": "right", "width": "134px" }}><Button {...{
                        ...editProps(col, order, rowIndex), onClick: () => {


                            if (window.bm_state.value !== route) {
                                kbdEvent(KBD.O);
                                return;
                            }

                            if (state?.view === "orders") {
                                setTimeout(() => {
                                    setFocusedCell({ row: rowIndex, col: "customer.name" })
                                }, 10)
                            } else {
                                switchView("orders");
                                setTimeout(() => {
                                    setFocusedCell({ row: rowIndex, col: "customer.name" })
                                }, 10)
                            }
                            toggleExpand(rowIndex);
                        }
                    }} type="link"><nobr>{(order?.customer) ? "S/O" : " +Cust/Note"}</nobr></Button>

                    </div>
                )
            }
        },

    ];

    const exFields = [
        { key: "customer.name", label: "Cust" },
        // { key: "customer.bill_to", label: "Act#" },
        // { key: "customer_type", label: "CustType" },
        { key: "customer.communication_preference", label: "Notify Via", skip: true },
        { key: "customer_po", label: "CustPO", skip: true },
        { key: "note.0", label: "Notes", autoselect: false },
        { key: "note.1", label: "Notes", autoselect: false },
        { key: "note.2", label: "Notes", autoselect: false },
        { key: "is_single_title_order", label: "STO", type: "checkbox" },
        { key: "is_prepay", label: "PRPY", type: "checkbox" },
        { key: "is_direct_to_home", label: "DTH", type: "checkbox" },
        { key: "status", label: "Stat" },
        { key: "status_date", label: "Date" },
        { key: "review_days", label: "Rvw" },
        { key: "review_date", label: "Rvw_Date" },

    ];



    if (splitter) {
        columns.push({
            splitter: true,
            key: "splitter",
        })

        columns.push({
            splitter: true,
            key: "ms_split",
            skip: true,
        })

        stores.forEach(item => {
            columns.push({
                splitter: true,
                key: item.san,
            })
        })
    }




    const drawSplitter = (order, rowIndex, expandedRows) => {

        if (!splitter) {
            return;
        }

        if (Object.keys(expandedRows).length > 0) {
            if (!expandedRows.hasOwnProperty(rowIndex)) {
                return;
            }
        }

        return (
            <tr>
                <td colSpan={columns.length}>
                    <div style={{ "borderTop": '1px solid var(--border-secondary)', "width": "maxContent", "borderRight": "1px solid var(--border-secondary)", "margin": "0px -5px", "padding": "0px 0px" }}>
                        <table style={{ "backgroundColor": "var(--card-bg)" }} className="ui-table">
                            <thead>
                                <tr key={"splitter"}>
                                    <th style={{ "textAlign": "left" }}>Splitter</th>
                                    {stores.map((store) => (
                                        <th style={{ "textAlign": "right" }} key={store.san}>#{store.chain_num}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                <tr key={"splitter_input"}>
                                    <td><Input chars={["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "."]} {...editProps({ key: "splitter" }, order, rowIndex)} onEnter={(e) => { handleSplitUpdate("splitter", e, rowIndex, order); kbdEvent(KBD.TAB) }} onBlur={(e) => handleSplitUpdate("splitter", e, rowIndex, order)} width={65} /></td>
                                    {stores.map((store, index) => {
                                        const _ms = getValue(order, "ms_split", rowIndex);
                                        const _value = getValue(order, store.san, rowIndex) || (_ms[store.chain_num] || 0)
                                        return (<td style={{ "textAlign": "right" }} key={store.san}><Input {...editProps({ key: store.san }, order, rowIndex)} onEnter={(e) => {
                                            handleSplitUpdate(index, e, rowIndex, order);

                                            if (index === store.length - 1) {
                                                // last field save
                                                kbdEvent(KBD.PAGE_DOWN)
                                            } else {
                                                kbdEvent(KBD.TAB)
                                            }
                                        }} onBlur={(e) => handleSplitUpdate(index, e, rowIndex, order)} number width={25} value={(focusedCell?.row === rowIndex) ? _value : (_value) ? _value : ""} /></td>)
                                    })}
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </td>
            </tr>

        )

    }


    const extraFields = (current?.customer) ? exFields : exFields.filter(item => !item?.skip);

    const getExtra = (key) => {
        const field = extraFields.find(field => field.key === key);
        return field || null;
    }



    const updateOrder = (rowIndex, key, value) => {

        const keys = key.split(".");

        const _c = { ...current };

        if (keys.length > 1) {

            if (isNaN(keys[1])) {
                _c[keys[0]][keys[1]] = value;
            } else {
                _c[keys[0]][parseInt(keys[1])] = value;
            }


        } else {

            _c[key] = value;
        }

        setCurrent({ ..._c });

    };



    const toggleExpand = (rowIndex) => {
        setExpandedRows((prev) => {
            const isCurrentlyExpanded = !!prev[rowIndex];
            const newState = {};
            if (!isCurrentlyExpanded) {
                newState[rowIndex] = true;
            }
            return newState;
        });
    };

    const handleKeyNavigation = useCallback(
        (key) => {
            const _columns = columns.filter(item => !item.skip);
            const { row, col } = focusedCell;
            const colIndex = _columns.findIndex((c) => c.key === col);
            let newRow = row;
            let newCol = col;

            const isExpanded = expandedRows[row];
            const efIndex = extraFields.findIndex((f) => f.key === col);

            if (key === KBD.ESCAPE) {

                if (isExpanded) {
                    setExpandedRows({});
                    setFocusedCell({ row: newRow, col: "customer" });

                    if (isEditOrder?.current) {
                        switchView("inventory");
                    }

                } else {
                    switchView("inventory");
                }
                return;
            }

            if (key === KBD.TAB || key === KBD.ARROW_RIGHT) {
                if (efIndex >= 0) {
                    if (efIndex < extraFields.length - 1) {
                        newCol = extraFields[efIndex + 1].key;
                    } else {
                        newCol = _columns[0]?.key;
                    }
                } else if (colIndex >= 0) {
                    if (colIndex < _columns.length - 1) {
                        newCol = _columns[colIndex + 1].key;
                    } else if (isExpanded) {
                        newCol = extraFields[0]?.key;
                    } else {
                        newCol = _columns[0]?.key;
                    }
                }

            } else if (key === KBD.SHIFT_TAB || key === KBD.ARROW_LEFT) {
                if (efIndex >= 0) {
                    if (efIndex > 0) {
                        newCol = extraFields[efIndex - 1].key;
                    } else {
                        newCol = _columns[_columns.length - 1]?.key;
                    }
                } else if (colIndex >= 0) {
                    if (colIndex > 0) {
                        newCol = _columns[colIndex - 1].key;
                    } else if (isExpanded) {
                        newCol = extraFields[extraFields.length - 1]?.key;
                    } else {
                        newCol = _columns[_columns.length - 1]?.key;
                    }
                }

            } else if (key === KBD.ARROW_DOWN) {
                if (isExpanded || row >= orders.length - 1) {
                    return;
                }
                newRow = row + 1;
                newCol = "quantity";
                setExpandedRows({});
            } else if (key === KBD.ARROW_UP) {
                if (isExpanded || row <= 0) {
                    return;
                }
                newRow = row - 1;
                newCol = "quantity";
                setExpandedRows({});
            }
            setFocusedCell({ row: newRow, col: newCol });
        },
        [focusedCell, columns, extraFields, orders, expandedRows, setExpandedRows, setFocusedCell, current]
    );



    useEffect(() => {
        if (loading || props.loading) { return; }
        const actions = [
            { key: KBD.TAB, action: () => { handleKeyNavigation(KBD.TAB) } },
            { key: KBD.COMMA, action: () => togglePubstock() },
            { key: KBD.SHIFT_TAB, action: () => handleKeyNavigation(KBD.SHIFT_TAB) },
            { key: KBD.ARROW_UP, action: () => handleKeyNavigation(KBD.ARROW_UP) },
            { key: KBD.ARROW_DOWN, action: () => handleKeyNavigation(KBD.ARROW_DOWN) },
            { key: KBD.ARROW_LEFT, action: () => { switchView("history", "history") } },
            { key: KBD.ESCAPE, action: () => handleKeyNavigation(KBD.ESCAPE) },
            { key: KBD.PAGE_DOWN, action: () => save() },
            { key: KBD.SHIFT_ENTER, action: () => handleKeyNavigation(KBD.SHIFT_TAB) },
            { key: KBD.H, action: () => switchView("history", "history") }

        ];
        const cleanup = listen(
            controller, route, actions, () => { }, [KBD.TAB, KBD.SHIFT_TAB, KBD.ARROW_LEFT, KBD.ARROW_RIGHT, KBD.ARROW_UP, KBD.ARROW_DOWN, KBD.ENTER, KBD.SHIFT_ENTER, KBD.ESCAPE, KBD.PAGE_DOWN, KBD.COMMA], [], []
        );
        return cleanup;
    }, [route, focusedCell, loading, props.loading, current]);


    const [canFetchMore, setCanFetchMore] = useState(true);

    const fetchMore = (_offset = 0) => {

        if (loading && _offset < 10) {
            return;
        }

        if (!canFetchMore) {
            return;
        }

        setLoading(true);

        let obj = {
            primary_code: fullData.stock.primary_code,
            condition_code: fullData.stock.condition_code,
            limit: 10,
            offset: _offset
        }

        pubCall("order.getPendingItem", obj, (_s, _r) => {
            if (_s) {
                if (Array.isArray(_r?.rows) && _r.rows.length !== 10) {
                    setCanFetchMore(false);
                }
                let _rows = addDefaultSell(_r.rows);
                setOrders(prev => [...prev, ..._rows]);
            } else {
                showError(_r)
            }
            setLoading(false)
        })
    }

    useEffect(() => {


        // Revert orders
        const { row, col } = focusedCell;
        const buffer = 4;
        const currentLength = orders.length - 1;
        const total = pending_orders.total;

        if ((orders.length > 10) && row >= currentLength - buffer && currentLength < total) {
            fetchMore(currentLength); // Placeholder for actual fetch function
        }



        setTimeout(() => {
            const refKey = `${row}-${col}`;
            if (refs.current[refKey]) {

                refs.current[refKey].focus();
                if (typeof refs.current[refKey].select === "function") {
                    if (!col.includes("note")) {
                        refs.current[refKey].select();
                    }
                }
            }
        }, 1)


    }, [focusedCell]);


    useEffect(() => {
        const { row, col } = focusedCell;
        setCurrent({ ...orders[row] });
    }, [focusedCell.row])




    const [focusedOnce, setFocusedOnce] = useState(false);

    useEffect(() => {

        if (!pending_orders?.rows || props.loading) return;
        const update = pending_orders.rows.map(item => {
            const _row = {
                ...item,
                sell_price: sell_price,
                store_profit_margin: calculateProfitMargin(sell_price, item.invoice_price, item.supplier_discount, 1)
            }
            return _row;
        });

        if (update.length > 0) {
            setOrders(update);
        }


        setFocusedOnce(false);


    }, [pending_orders, sell_price]);



    useEffect(() => {

        if (window.bm_state.value === route && orders.length > 0) {
            if (!focusedOnce) {
                setFocusedOnce(true);

            }

        }

    }, [window.bm_state.value, orders, focusedOnce, route]);


    useEffect(() => {

        if (window.bm_state.value === route) {
            kbdEvent(KBD.ESCAPE);
        }

    }, [props.selected])






    useEffect(() => {


        if (window.bm_state.value === route) {
            if (focusedOnce) {
                if (splitter) {
                    //setFocusedCell({ row: 0, col: "quantity" });
                    setFocusedCell({ row: 0, col: "splitter" });
                } else {

                    if (!focusedCell.hasOwnProperty("row")) {
                        setFocusedCell({ row: 0, col: "quantity" });
                    }

                }

                setCanFetchMore(true);
            }
        }

        if (window.bm_state.value === ROUTES.INVENTORY.INVENTORY) {
            setExpandedRows({})
            setCurrent({})
            setFocusedCell({})

        }

    }, [window.bm_state.value, focusedOnce, props.selected]);




    const handleSplitUpdate = (source, changedValue, rowIndex, order) => {

        const rawMsValues = getValue(order, "ms_split", rowIndex);

        let ms_values = [...stores].map(() => 0);

        if (Array.isArray(rawMsValues) && rawMsValues.length === stores.length) {
            // Array matches
            ms_values = [...rawMsValues];
        } else if (Array.isArray(rawMsValues) && rawMsValues.length > stores.length) {
            // Map to stores
            let _new = [];
            stores.forEach((store) => {
                _new.push(rawMsValues[store.chain_num]);
            });
            ms_values = _new;
        }

        //const ms_values = Array.isArray(rawMsValues) && rawMsValues.length ? [...rawMsValues] : stores.map(() => 0);
        const quantity = Number(getValue(order, "quantity", rowIndex));
        const numStores = stores.length;
        const primaryIndex = myStoreIndex;  //stores.findIndex(s => s.primary);

        const setMsValuesAndQuantity = (newVals, overide_total = false) => {
            const total = newVals.reduce((a, b) => a + b, 0);
            const updated = { ...current };
            stores.forEach((store, index) => {
                updated[store.san] = newVals[index];
                if (full_split.current) {
                    full_split.current[store.chain_num] = newVals[index];
                }
            });
            updated.ms_split = newVals;
            updated.splitter = "";

            if (overide_total !== false) {
                updated.quantity = overide_total;
            } else {
                updated.quantity = total;
            }

            setCurrent(updated);
        };

        if (source === "splitter") {




            const splitter = String(changedValue).trim();

            if (!splitter.includes(".")) {
                // 
                if (!isNaN(splitter) && parseInt(splitter) > 0) {
                    // behave like i'm updating quantity
                    handleSplitUpdate("quantity", changedValue, rowIndex, order);
                    return;
                } else {
                    handleSplitUpdate("quantity", getValue(order, "quantity", rowIndex), rowIndex, order);
                }
            }

            if (splitter === ".") {
                const even = Math.floor(quantity / numStores);
                const remainder = quantity % numStores;
                const newVals = ms_values.map((_, i) => i < remainder ? even + 1 : even);
                return setMsValuesAndQuantity(newVals);
            }

            if (splitter.startsWith(".")) {
                const q = Number(splitter.slice(1));
                if (isNaN(q)) return;
                const newVals = stores.map(() => q);
                return setMsValuesAndQuantity(newVals);
            }

            const match = splitter.match(/^(\d+)\.(\d+)$/);
            if (match) {
                const chainNum = parseInt(match[1]);
                const val = parseInt(match[2]);

                const storeIndex = stores.findIndex(s => s.chain_num === chainNum);
                if (storeIndex === -1) return;

                const newVals = [...ms_values];
                newVals[storeIndex] = val;
                return setMsValuesAndQuantity(newVals);
            }

            return;
        }

        if (source === "quantity") {
            const newQuantity = Number(changedValue);
            const currentTotal = ms_values.reduce((a, b) => a + b, 0);
            const delta = newQuantity - currentTotal;

            const newVals = [...ms_values];

            if (delta > 0) {
                // add to "my" store
                newVals[primaryIndex] += delta;
            } else if (delta < 0) {
                let currentTotal = newVals.reduce((a, b) => a + b, 0);
                while (currentTotal > newQuantity) {
                    let maxIndex = 0;
                    for (let i = 1; i < newVals.length; i++) {
                        if (newVals[i] >= newVals[maxIndex]) {
                            maxIndex = i;
                        }
                    }
                    newVals[maxIndex] -= 1;
                    currentTotal -= 1;
                }
            }

            return setMsValuesAndQuantity(newVals);
        }

        if (typeof source === "number") {
            const idx = source;
            const inputVal = Number(changedValue);
            if (isNaN(inputVal)) return;

            const oldVal = ms_values[idx];
            const delta = inputVal - oldVal;
            const newVals = [...ms_values];
            newVals[idx] = inputVal;

            if (idx === primaryIndex) {
                const newTotal = newVals.reduce((a, b) => a + b, 0);
                setMsValuesAndQuantity(newVals, newTotal);
            } else {
                const primaryVal = newVals[primaryIndex];
                const reduction = Math.min(primaryVal, delta);
                newVals[primaryIndex] = primaryVal - reduction;

                const newTotal = newVals.reduce((a, b) => a + b, 0);
                setMsValuesAndQuantity(newVals, newTotal);
            }

            return;
        }

    }



    const getValue = (order, key, rowIndex) => {




        const keys = key.split(".");

        if (focusedCell?.row !== 0 && rowIndex === 0) {
            return "";
        }

        if (focusedCell?.row === rowIndex) {
            if (keys.length > 1) {
                return current?.[keys[0]]?.[keys[1]] ?? "";
            }
            return current?.[key] ?? "";
        }

        if (keys.length > 1) {
            return order?.[keys[0]]?.[keys[1]] ?? "";
        }
        return order?.[key] ?? "";
    };


    useEffect(() => {

        const { row, col } = focusedCell;
        if (rowRefs.current[`${row}`]) {

            if (expandedRows) {
                rowRefs.current[`${row}`].scrollIntoView({ behavior: "smooth", block: "nearest" });
            } else {
                rowRefs.current[`${row}`].scrollIntoView({ behavior: "smooth", block: "nearest" });
            }

        }

    }, [focusedCell, expandedRows])


    const selectCustomer = (_search = "") => {
        const { row, col } = focusedCell;
        const refKey = `${row}-${col}`;
        refs.current[refKey].blur();
        window.bm_state.value = ROUTES.CUSTOMER.CUSTOMER;
        createScreen({
            signal: _signal,
            component: <CustomersController controller={controller} is_modal search={_search} route={ROUTES.CUSTOMER.CUSTOMER} />, closable: false, title: "Select Customer",
            callback: (_obj) => {
                window.bm_state.value = route;
                if (_obj) {
                    refs.current[refKey].value = _obj.name;
                    updateOrder(row, "customer", _obj);
                } else {
                    refs.current[refKey].value = _search;
                }
                refs.current[refKey].focus();
                setTimeout(() => {
                    kbdEvent(KBD.TAB);
                }, 100)

            }
        });
    }


    function setReviewField(type, value, row_index) {
        const now = dayjs().utc().startOf('day');
        if (type === "days") {
            let days = Math.max(0, Math.min(parseInt(value, 10) || 0, 999));
            let date = now.add(days, 'day').unix();
            updateOrder(row_index, "review_days", days);
            updateOrder(row_index, "review_date", date);
        } else {
            let inputTimestamp = parseInt(value, 10) || 0;
            let inputDate = dayjs.unix(inputTimestamp).utc().startOf('day');
            let days = inputDate.diff(now, 'day');
            days = Math.max(0, Math.min(days, 999));
            let date = now.add(days, 'day').unix();
            updateOrder(row_index, "review_days", days);
            updateOrder(row_index, "review_date", date);
        }
    }

    const statusEnum = (_ref, _value, _rowIndex) => {
        _ref.blur();
        drawPicker({
            controller : controller,
            value: _value, title: "Select Status", closeable: true, height: 300, ref: null, route: route, close: () => { _ref.focus(); }, callback: (e) => {
                if (e) {
                    updateOrder(_rowIndex, "status", e);
                }
                _ref.focus();
                setTimeout(() => {
                    kbdEvent(KBD.TAB);
                }, 100)

            }, offset: [0, 10],
            options: ENUMS.ORDER_STATUS
        })
    }


    const notifyEnum = (_ref, _value, _rowIndex) => {
        _ref.blur();
        drawPicker({
            controller : controller,
            value: _value, title: "Notify Via", closeable: true, height: 300, ref: null, route: route, close: () => { _ref.focus(); }, callback: (e) => {
                if (e) {
                    updateOrder(_rowIndex, "customer.communication_preference", e);
                }
                _ref.focus();
                setTimeout(() => {
                    kbdEvent(KBD.TAB);
                }, 100)

            }, offset: [0, 10],
            options: ENUMS.COMM_PREF
        })

    }


    const isExpanded = () => {
        const keys = Object.keys(expandedRows);
        return keys.length === 1 && expandedRows[keys[0]];
    };

    const getRowHeight = (rowIndex, focusedIndex = 0, isExpanded, totalRows) => {

        // Hide placeholder if there are pending orders and not inside orders
        if (state.view !== "orders" && orders.length > 1 && rowIndex === 0) {
            return "0px"
        }

        if (isExpanded) {
            // Only show the focused row
            return rowIndex === focusedIndex ? "32px" : "0px";
        }

        const maxVisible = Math.min(7, totalRows);

        // Prefer showing focusedIndex and 6 before it
        let startIndex = Math.max(0, focusedIndex - (maxVisible - 1));
        let endIndex = startIndex + maxVisible - 1;

        // Clamp endIndex if it goes out of bounds
        if (endIndex >= totalRows) {
            endIndex = totalRows - 1;
            startIndex = Math.max(0, endIndex - (maxVisible - 1));
        }

        const inVisibleWindow = rowIndex >= startIndex && rowIndex <= endIndex;
        return inVisibleWindow ? "32px" : "0px";
    };


    const cols = columns.filter(item => !item.splitter);



    const getHeight = () => {
        let _h = 0;
        return "auto";

        if (splitter) {
            _h += 50;
        }

        return (_h + "px");

    }


    return (
        <Spin

            style={{ height: "100%", display: "flex", flexDirection: "column", flex: "1 1 0%", }}
            loading={loading || props.loading}
        >
            <div
                onClick={() => {
                    if (window.bm_state.value !== route) {
                        kbdEvent(KBD.O);
                        return;
                    }
                }}
                className={"cust-shift-down"}
                style={{
                    display: "flex",
                    flexDirection: "column",
                    height: "100%",
                    minHeight: "0",
                }}
            >
                <div
                    style={{
                        minHeight: "0",
                        borderBottomLeftRadius: "0px",
                        borderBottomRightRadius: "0px",
                        backgroundColor: "var(--card-bg)",
                        borderBottom: "0px"
                    }}
                    className="ui-table-container no-scrollbar"
                >



                    <table style={{ width: "100%", backgroundColor: "var(--card-bg)" }} className={(isExpanded() ? "ui-table stretch-last shadow" : "ui-table stretch-last")}>
                        <thead style={{ position: "sticky", top: 0, zIndex: 1, background: "var(--card-bg)" }}>
                            <tr>
                                {cols.map((col) => (
                                    <th style={{ "textAlign": "left" }} key={col.key}>{col.label}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody>

                            {orders.map((order, rowIndex) => (
                                <React.Fragment key={(order.order_id) ? order.order_id : fullData?.stock_id}>
                                    <tr onDoubleClick={(e) => {
                                        switchView("orders")
                                        e.preventDefault();
                                        e.stopPropagation();

                                    }} ref={(el) => (rowRefs.current[`${rowIndex}`] = el)}>
                                        {cols.map((col) => (
                                            <td style={{ "height": "auto" }} key={col.key}>
                                                <div style={{ height: getRowHeight(rowIndex, focusedCell?.row ?? -1, isExpanded(), orders.length), overflow: "hidden" }}>
                                                    <div style={{ "paddingTop": "4px" }}>{(col?.render && col.render(col, order, rowIndex))}</div>
                                                </div>
                                            </td>
                                        ))}
                                    </tr>
                                    {drawSplitter(order, rowIndex, expandedRows)}
                                    {expandedRows[rowIndex] && (
                                        <tr>
                                            <td colSpan={cols.length}>
                                                <div>
                                                    <div className="shim" />
                                                    <Space grow>
                                                        <Label style={{ "width": "39px" }}>Cust</Label>
                                                        <Input
                                                            style={{ width: "144px" }}
                                                            {...editProps(getExtra("customer.name"), order, rowIndex)}
                                                            controlled={false}
                                                            onChange={(e) => {
                                                                if (!e) {
                                                                    updateOrder(rowIndex, "customer", null);
                                                                }
                                                            }}
                                                            value={getValue(order, "customer.name", rowIndex)}
                                                            onEnter={(e) => selectCustomer(e)}
                                                        />
                                                        <Label>Act#</Label>
                                                        <Label width={100} style={{ "color": "var(--text-light)", "textAlign": "left" }}>{getValue(order, "customer.ship_to", rowIndex)}</Label>
                                                        <Label>CustType</Label>
                                                        <Label width={20} style={{ "color": "var(--text-light)", "textAlign": "left" }}>{getValue(order, "customer_type", rowIndex)}</Label>
                                                    </Space>
                                                    <div className="shim" />
                                                    <Space grow>
                                                        <Label style={{ "width": "39px" }}>Notify</Label>
                                                        <Input uppercase maxLength={1} onPageUp={() => notifyEnum(refs.current[`${rowIndex}-customer.communication_preference`], getValue(order, "customer.communication_preference", rowIndex), rowIndex)} {...editProps(getExtra("customer.communication_preference"), order, rowIndex)} value={getValue(order, "customer.communication_preference", rowIndex)} edit={canEdit(order)} className={(current?.customer) ? "" : "dim"} width={20} />
                                                        <Label width={213}>CustPO#</Label>
                                                        <Input   {...editProps(getExtra("customer_po"), order, rowIndex)} edit={(current?.customer && canEdit(order))} className={(current?.customer) ? "" : "dim"} width={127} />
                                                    </Space>
                                                    <div className="shim" />
                                                    <Space style={{ "alignItems": "flex-start" }} grow>
                                                        <Label style={{ "width": "39px" }}>Notes</Label>
                                                        <Space size={0} flexDirection="column">
                                                            <Input style={{ "borderBottomLeftRadius": "0px", "borderBottomRightRadius": "0px", "fontFamily": "monospace", "fontSize": "17px" }} width={383} tabMax={() => { refs.current[`${rowIndex}-note.1`].focus(); }} maxLength={40} {...editProps(getExtra("note.0"), order, rowIndex)} edit={canEdit(order)} autoselect={false} />
                                                            <Input style={{ "borderRadius": "0px", "fontFamily": "monospace", "fontSize": "17px" }} width={383} tabMin={() => refs.current[`${rowIndex}-note.0`].focus()} tabMax={() => { refs.current[`${rowIndex}-note.2`].focus(); }} maxLength={40} {...editProps(getExtra("note.1"), order, rowIndex)} edit={canEdit(order)} autoselect={false} />
                                                            <Input style={{ "borderTopLeftRadius": "0px", "borderTopRightRadius": "0px", "fontFamily": "monospace", "fontSize": "17px" }} width={383} tabMin={() => refs.current[`${rowIndex}-note.1`].focus()} maxLength={40} {...editProps(getExtra("note.2"), order, rowIndex)} edit={canEdit(order)} autoselect={false} />
                                                        </Space>
                                                    </Space>
                                                    <div className="shim" />
                                                    <Space grow>
                                                        <Label style={{ "width": "39px" }}>&nbsp;</Label>
                                                        <Space size={30}>
                                                            <Checkbox {...editProps(getExtra("is_single_title_order"), order, rowIndex)}><Label>Single Title Order</Label></Checkbox>
                                                            <Checkbox {...editProps(getExtra("is_prepay"), order, rowIndex)}><Label>Prepay</Label></Checkbox>
                                                            <Checkbox {...editProps(getExtra("is_direct_to_home"), order, rowIndex)}><Label>Direct to home</Label></Checkbox>
                                                        </Space>
                                                    </Space>
                                                    <div className="shim" />
                                                    <Space  >
                                                        <Label style={{ "width": "39px" }}>Status</Label>
                                                        <Input onPageUp={() => statusEnum(refs.current[`${rowIndex}-status`], getValue(order, "status", rowIndex), rowIndex)} {...editProps(getExtra("status"), order, rowIndex)} width={53} />
                                                        <DateField {...editProps(getExtra("status_date"), order, rowIndex)} width={89} />
                                                        <Label width={65}>Review</Label>
                                                        <Input number maxLength={3} {...editProps(getExtra("review_days"), order, rowIndex)} onChange={(e) => setReviewField("days", e, rowIndex)} right width={33} />
                                                        <DateField maxLength={10} {...editProps(getExtra("review_date"), order, rowIndex)} onEnter={(e) => setReviewField("date", e, rowIndex)} onChange={(e) => setReviewField("date", e, rowIndex)} width={89} value={getValue(order, "review_date", rowIndex)} />
                                                    </Space>
                                                    <div className="shim" />
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </React.Fragment>
                            ))}
                        </tbody>
                    </table>

                </div>




                <div style={{ flex: 1, alignItems: "flex-end", display: "flex", backgroundColor: "var(--input-bg)", border: "1px solid var(--border-secondary)" }}>{props.pubstock}</div>
                {/* <div style={{ flex: 1, backgroundColor: "var(--input-bg)", border: "1px solid var(--border-secondary)" }}>{props.pubstock}</div> */}
            </div>

        </Spin>
    );
}